export class ChipType {
  id: number | string;
  name: string;

  constructor(name: string, id?: number | string) {
    this.name = name;
    if (id) this.id = id;
  }
}
